import { memo } from 'react';

import { InceptIcon, InceptIconProps } from '../InceptIcon';

type SecurityIconProps = Omit<InceptIconProps, 'children' | 'viewBox'> & {
  viewBox?: string;
};

const SecurityIconComponent: React.FC<SecurityIconProps> = ({
  color = 'var(--chakra-colors-brand-primary-solid, #30B7FD)',
  fillColor = 'var(--chakra-colors-brand-primary-fg, #092B49)',
  viewBox = '0 0 64 64',
  ...props
}: SecurityIconProps) => (
  <InceptIcon viewBox={viewBox} {...props}>
    <g clipPath="url(#security-icon-clip)">
      <path
        d="M28.2055 39.3629C27.8554 39.3636 27.5219 39.2099 27.2947 38.9432L20.9689 31.5356C20.5393 31.0324 20.5987 30.2766 21.1019 29.8469C21.6051 29.4179 22.3609 29.4773 22.7906 29.9799L28.3566 36.4981L42.1808 25.2513C42.6941 24.8336 43.4485 24.9111 43.8655 25.4243C44.2832 25.9376 44.2057 26.692 43.6924 27.109L28.96 39.0943C28.7475 39.268 28.4808 39.3629 28.2055 39.3629Z"
        fill={color as string}
      />
      <path
        d="M27.8107 62.4856L31.0571 63.9003C31.3605 64.0326 31.7059 64.0333 32.01 63.9016L35.668 62.3219C48.512 56.9277 56.8679 44.3564 56.8692 30.4259V14.0154C56.8692 13.573 56.6253 13.1661 56.2351 12.9582L32.1811 0.141024C31.8242 -0.0494298 31.3965 -0.0467569 31.0424 0.147707L7.65395 12.9649C7.27037 13.1754 7.03247 13.5777 7.03247 14.0154V30.758C7.0465 44.5208 15.2006 56.9718 27.8107 62.4856ZM9.42751 14.7244L31.6257 2.55812L54.4742 14.7331V30.4259C54.4715 43.3961 46.6896 55.0993 34.7305 60.1186L34.7218 60.1226L31.5369 61.4979L28.7689 60.2904C17.031 55.1581 9.44021 43.5692 9.42684 30.758L9.42751 14.7244Z"
        fill={fillColor as string}
      />
    </g>
    <defs>
      <clipPath id="security-icon-clip">
        <rect fill="white" height="64" width="64" />
      </clipPath>
    </defs>
  </InceptIcon>
);

export const SecurityIcon = memo(SecurityIconComponent);
